/* eslint-disable @next/next/no-img-element */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect, useRef } from 'react'
import { ArticleJsonLd } from 'next-seo'
import Head from 'next/head'
import PropTypes from 'prop-types'
import useCMS from '../../hooks/useCMS'
import SharingComponent from '../../components/Sharing'
import Layout from '../../components/Layout'
import useFallback from '../../hooks/useFallback'

export default function BlogSubpage({ article }) {
  const { urlFor } = useCMS()
  const fallback = useFallback()
  const [currentHeader, setCurrentHeader] = useState()
  const headerRef = useRef()

  if (fallback) {
    return fallback
  }

  useEffect(() => {
    const listener = () => {
      // const header = headerRef.current || 1
      // const nextHeader = parseInt(header) + 1

      if (!headerRef.current) {
        const pastFirstHeader =
          window.scrollY >=
          document.getElementById('1').getBoundingClientRect().y

        if (!pastFirstHeader) {
          return
        } else {
          headerRef.current = 1
          setCurrentHeader(1)
        }
      }

      // const pastCurrentHeader =
      //   window.scrollY >=
      //   document.getElementById(header.toString()).getBoundingClientRect().y

      // eslint-disable-next-line max-len
      // const nextHeaderElement = document.getElementById(nextHeader.toString())

      // if (!nextHeaderElement) {
      //   return
      // }

      // const pastNextHeader =
      //   window.scrollY >= nextHeaderElement.getBoundingClientRect().y

      // if (pastCurrentHeader && !pastNextHeader) {
      //   setCurrentHeader(header)
      //   headerRef.current = header
      // } else {
      //   setCurrentHeader(nextHeader)
      //   headerRef.current = nextHeader
      // }
      // console.log(window.scrollY)
    }

    window.addEventListener('scroll', listener)

    return () => {
      window.removeEventListener('scroll', listener)
    }
  }, [])

  return (
    <main>
      <Head>
        <link
          rel="canonical"
          href={`https://www.tubetranscripts.com/blog/${article.slug.current}`}
          key="canonical"
        />
        <meta
          name="description"
          content={article.description}
          key="description"
        />

        <title key="title">{article.title}</title>

        <meta property="og:title" content={article.metaTitle} key="og-title" />
        <meta
          property="og:description"
          content={article.description}
          key="og-description"
        />
        <meta
          property="og:url"
          content={`https://www.tubetranscripts.com/blog/${article.slug.current}`}
          key="og-url"
        />
        <meta property="og:type" content="article" key="og:type" />
        <meta
          property="og:image"
          content={urlFor(article.mainImage)}
          key="og:image"
        />
      </Head>
      <ArticleJsonLd
        url={`https://www.tubetranscripts.com/blog/${article.slug.current}`}
        title={article.title}
        images={[urlFor(article.mainImage).url()]}
        datePublished={article.publishedAt}
        authorName={article.author.name}
        publisherName="Tube Transcripts"
        description={article.description}
      />
      <div className="flex flex-col items-center justify-center w-full mt-12">
        <img
          className="object-cover object-top scale-100 rounded-lg w-96"
          src={urlFor(article.mainImage)}
          alt={article.mainImage.alt}
        />
        <a
          href={`/blog/category/${article.categories[0].slug.current}`}
          className="mt-4 text-sm font-bold text-purple-500 uppercase">
          {article.categories[0].title}
        </a>
        <h1 className="w-full max-w-2xl px-8 mt-6 text-4xl font-extrabold text-center text-gray-800 font-body lg:text-5xl">
          {article.title}
        </h1>
        <div className="flex items-center justify-center max-w-4xl px-2 mx-auto mt-6 xl:px-0">
          <a
            href={`/blog/author/${article.author.slug.current}`}
            className="ml-2 mr-2 text-lg font-extrabold text-center text-gray-500 underline decoration-gray-400 font-body">
            {article.author.name}
          </a>
          <div className="w-1 h-1 bg-gray-400 rounded-full" />
          <p className="ml-2 text-lg font-extrabold text-center text-gray-400 font-body">
            <time dateTime={article.publishedAt}>
              {new Date(article.publishedAt).toLocaleDateString()}
            </time>
          </p>
        </div>
        <div className="grid w-full grid-cols-12 mt-24">
          <div className="hidden col-span-3 pl-8 lg:block">
            <div className="sticky py-8 pl-24 pr-4 text-sm text-gray-400 top-2">
              <ol className="space-y-3 list-decimal list-outside decoration-gray-200">
                {article.headers.map((header, index) => {
                  return (
                    <li
                      key={`header-${index}`}
                      className={`${
                        currentHeader === index + 1 ? 'text-gray-800' : ''
                      } hover:text-gray-800`}>
                      <a
                        onClick={() => setCurrentHeader(index + 1)}
                        href={`#${index + 1}`}>
                        {header}
                      </a>
                    </li>
                  )
                })}
              </ol>
            </div>
          </div>
          <div className="flex flex-col max-w-3xl col-span-12 px-8 pb-20 lg:col-span-6 bg-gray-50 rounded-2xl md:px-16">
            <div
              className="max-w-3xl"
              dangerouslySetInnerHTML={{ __html: article.body }}
            />
          </div>
          <div className="hidden col-span-3 px-4 lg:block">
            {/* <SharingComponent sticky /> */}
          </div>
        </div>
        <div className="relative flex mt-24 rounded-2xl"></div>
        <div className="w-11/12 max-w-3xl mt-8 lg:px-0">
          <SharingComponent
            url={`https://www.tubetranscripts.com/blog/${article.slug.current}`}
            title={article.title}
          />
        </div>
      </div>
    </main>
  )
}

export async function getStaticProps(context) {
  const {
    params: { slug },
  } = context

  const { getArticle } = useCMS()
  const article = await getArticle(slug)

  return {
    props: {
      article,
    },
    revalidate: 600,
  }
}

export async function getStaticPaths() {
  const { getArticles } = useCMS()
  const articles = await getArticles()

  const paths = articles.map((a) => {
    return {
      params: { slug: a.slug.current },
    }
  })

  return {
    paths: paths,
    fallback: true,
  }
}

BlogSubpage.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>
}

BlogSubpage.propTypes = {
  article: PropTypes.object.isRequired,
}
